module.exports = __webpack_public_path__ + "static/img/dummy.b446d8e7.png";